import { EventEmitter, Injectable, Type } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormsModalComponent } from '../../shared/components/modals/forms-modal/forms-modal.component';

@Injectable({
  providedIn: 'root',
})
export class DynamicModalService {
  private modalData: any = null;
  private currentModalTitle: string | null = null;
  modalClosed = new EventEmitter<void>();
  bonusCreated = new EventEmitter<void>();
  modalStateChanged = new EventEmitter<{
    title: string | null;
    isOpen: boolean;
    isMinimized: boolean;
  }>();

  constructor(private modalService: NgbModal) {}
  openModal(
    component: Type<any>,
    title: string,
    size?: string,
    position?: boolean,
    args?: any,
    onSuccess?: () => void
  ) {
    this.modalData = args;
    this.currentModalTitle = title;
    const modalRef = this.modalService.open(FormsModalComponent, {
      centered: position,
      size: size || 'lg',
      backdrop: 'static',
      keyboard: false,
    });
    modalRef.result.then(
      () => {
        this.modalClosed.emit();
        this.emitModalState(false, false, title);
        this.clearModalData();
      },
      () => {
        this.emitModalState(false, false, title);
        this.clearModalData();
      }
    );
    modalRef.componentInstance.component = component;
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.isEditForm = args?.isEditForm || false;
    modalRef.componentInstance.tipoTransaccion = args?.tipoTransaccion;
    modalRef.componentInstance.fotoComprobante = args?.fotoComprobante;
    modalRef.componentInstance.id_financiero = args?.id_financiero;
    modalRef.componentInstance.id_material = args?.id_material;
    modalRef.componentInstance.is_edit_material = args?.is_edit_material;
    modalRef.componentInstance.args = args;
    this.emitModalState(true, false, title);
    return modalRef;
  }

  getModalData() {
    return this.modalData;
  }

  clearModalData() {
    this.modalData = null;
    this.currentModalTitle = null;
  }

  closeModal() {
    this.modalService.dismissAll();
    this.emitModalState(false, false);
    this.modalClosed.emit();
    this.clearModalData();
  }

  notifyBonusCreated() {
    this.bonusCreated.emit();
  }

  updateModalState(title: string, isOpen: boolean, isMinimized: boolean) {
    this.currentModalTitle = isOpen ? title : null;
    this.modalStateChanged.emit({
      title,
      isOpen,
      isMinimized,
    });
  }

  private emitModalState(
    isOpen: boolean,
    isMinimized: boolean,
    title: string | null = this.currentModalTitle
  ) {
    this.modalStateChanged.emit({
      title,
      isOpen,
      isMinimized,
    });
  }
}
